import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';

import { JdsTag } from '../../../components/jds/JdsTag';
import { ItemStatusBadge } from './ItemStatusBadge';
import { formatCurrency, parseDisplayClient } from '../utils';
import { JdsMoreToggle } from '../../../components/jds/JdsMoreToggle';
import { jdsMenuPopperConfig } from '../../../components/jds/popper';

const visibilityConfig = {
  true: { label: 'Sim', color: 'success' },
  false: { label: 'Não', color: 'neutral' },
};

// RDT só dispara onRowClicked quando e.target tem data-tag="allowRowEvents"
// (comparação exata, sem subir pela árvore). A célula já traz o atributo; no
// conteúdo customizado, o alvo precisa ser o próprio elemento (data-tag) ou a
// própria célula (filhos com pointer-events: none, que é herdado).
const passClicksToRow = { pointerEvents: 'none' };

export const columns = [
  {
    name: <span className="sr-only">Opções</span>,
    selector: (row) => row.id,
    width: '56px',
    center: true,
    cell: (row) => (
      <Dropdown>
        <Dropdown.Toggle
          as={JdsMoreToggle}
          variant="ghost"
          size="sm"
          id={`items-options-${row.id}`}
          aria-label={`Abrir opções do produto ${row.name || ''}`}
          title="Abrir opções"
        />

        <Dropdown.Menu alignRight popperConfig={jdsMenuPopperConfig}>
          <Dropdown.Item as={Link} to={`/payments/items/${row.id}`}>
            Visualizar
          </Dropdown.Item>

          <Dropdown.Item as={Link} to={`/payments/items/${row.id}/edit`}>
            Editar
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },
  {
    name: 'Código do produto',
    selector: (row) => row.code,
    minWidth: '140px',
    maxWidth: '220px',
    cell: (row) => (
      <code
        data-tag="allowRowEvents"
        className="items-cell--code items-cell--truncate"
        title={row.code || '-'}
      >
        {row.code || '-'}
      </code>
    ),
  },
  {
    name: 'Nome do produto',
    selector: (row) => row.name,
    minWidth: '140px',
    maxWidth: '480px',
    grow: 1,
    cell: (row) => (
      <div
        data-tag="allowRowEvents"
        className="items-cell--truncate"
        title={row.name || '-'}
      >
        {row.name || '-'}
      </div>
    ),
  },
  {
    name: 'Valor',
    selector: (row) => row.price ?? row.value,
    width: '100px',
    center: true,
    cell: (row) => (
      <span data-tag="allowRowEvents" className="items-cell--currency">
        {formatCurrency(row.price ?? row.value)}
      </span>
    ),
  },
  {
    name: 'Status',
    width: '110px',
    center: true,
    cell: (row) => (
      <div style={passClicksToRow}>
        <ItemStatusBadge item={row} />
      </div>
    ),
  },
  {
    name: 'Visível',
    width: '110px',
    center: true,
    cell: (row) => {
      const displayClient =
        row.display_client !== undefined
          ? row.display_client
          : row.displayClient;

      const config =
        visibilityConfig[String(parseDisplayClient(displayClient))] ||
        visibilityConfig.false;

      return (
        <div style={passClicksToRow}>
          <JdsTag label={config.label} color={config.color} dot />
        </div>
      );
    },
  },
];
